import { APIEndpoints } from "@/data/constants/endpoints";
import { Request } from "@/data/api/utils/network";
import { RequestParams } from "@/data/types";
import { TPermissionItem, TPermissionPayload } from "@/data/types";

/**
 * Get all permissions with pagination options
 * @param params Request parameters including organization_id, pageNumber, pageSize, etc.
 */
export const getAllPermissions = (params: RequestParams) => {
  return Request({
    path: APIEndpoints.PERMISSIONS.BASE,
    type: "GET",
    params,
  });
};

/**
 * Get a permission by ID
 * @param permissionId The ID of the permission to retrieve
 * @param params Request parameters
 */
export const getPermissionById = (permissionId: string, params: RequestParams) => {
  return Request({
    path: APIEndpoints.PERMISSIONS.BY_ID(permissionId),
    type: "GET",
    params,
  });
};
